import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from 'context';
import ScrollToTop from 'components/V1/ScrollToTop/ScrollToTop';
import App from './App';
import { apiMode } from 'utils/env';

function render() {
  const container = document.getElementById('root');

  if (!container) {
    throw new Error('Root container #root not found');
  }

  createRoot(container).render(
    <React.StrictMode>
      <AppProviders>
        <ScrollToTop />
        <App />
      </AppProviders>
    </React.StrictMode>
  );
}

if (apiMode === 'mock') {
  import('./test/browser').then(render);
} else {
  render();
}
